import { useTranslation } from 'react-i18next';

import { CheckCircleIcon, CloseIcon } from 'components/icons';
import Button, { ButtonVariant } from 'components/Button';
import HideComponent from 'components/HideComponent';

type ConfirmDialogProps = {
  title?: string;
  text?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
};

export const SuccessDialog: React.FC<ConfirmDialogProps> = ({
  title,
  text,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation('common');

  return (
    <div className="pt-14 px-6 pb-6 relative">
      <Button
        onClick={onCancel}
        className="absolute top-4 right-4"
        paddingClass="p-2"
        variant={ButtonVariant.link}
        heightClass="h-10"
      >
        <CloseIcon className="w-6 h-6 text-gray-400" />
      </Button>

      <div className="flex justify-center mb-6">
        <CheckCircleIcon className="text-green-500 w-11 h-11" />
      </div>

      <HideComponent show={title !== undefined}>
        <p className="text-lg font-semibold text-gray-900 mb-2 text-center">
          {title}
        </p>
      </HideComponent>

      <HideComponent show={text !== undefined}>
        <p className="text-secondary mb-6 text-center">{text}</p>
      </HideComponent>

      <HideComponent show={onConfirm !== undefined}>
        <Button
          className="w-full mb-4"
          variant={ButtonVariant.primary}
          heightClass="h-12"
          onClick={onConfirm}
        >
          {t('confirm')}
        </Button>
      </HideComponent>

      <HideComponent show={onCancel !== undefined}>
        <Button
          className="w-full"
          variant={ButtonVariant.secondaryOutline}
          heightClass="h-12"
          onClick={onCancel}
        >
          {t('cancel')}
        </Button>
      </HideComponent>
    </div>
  );
};

export default SuccessDialog;
